import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { useTranslation } from "../../i18n/useTranslation";

const STATUS_COLORS = {
  draft: {
    light: { bg: "#f1f5f9", text: "#94a3b8", dot: "#94a3b8" },
    dark:  { bg: "#1e293b", text: "#64748b", dot: "#64748b" },
  },
  published: {
    light: { bg: "#f0fdf4", text: "#166534", dot: "#16a34a" },
    dark:  { bg: "rgba(22,163,74,0.12)", text: "#86efac", dot: "#4ade80" },
  },
  closed: {
    light: { bg: "#fef3c7", text: "#92400e", dot: "#d97706" },
    dark:  { bg: "rgba(217,119,6,0.12)", text: "#fcd34d", dot: "#fbbf24" },
  },
};

export default function StatusBadge({ status = "draft", isDarkMode }) {
  const { t } = useTranslation();
  const colorConfig = STATUS_COLORS[status] || STATUS_COLORS.draft;
  const colors = isDarkMode ? colorConfig.dark : colorConfig.light;
  const labelMap = { draft: t("Draft"), published: t("Published"), closed: t("Closed") };
  const label = (labelMap[status] || status).toUpperCase();

  return (
    <View style={[styles.badge, { backgroundColor: colors.bg }]}>
      <View style={[styles.dot, { backgroundColor: colors.dot }]} />
      <Text style={[styles.label, { color: colors.text }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 20,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  label: {
    fontSize: 11,
    fontWeight: "700",
    letterSpacing: 0.3,
    textTransform: "uppercase",
  },
});
